import { OrderExtraStatusAttributes } from '@albatrosdeveloper/ave-models-package';
import { DateTime } from 'luxon';

export const formatLuxonDate = (date: any, formatStr: string): string => {
  if (!date) return '-';
  try {
    let dt: DateTime | null = null;
    if (date instanceof Date) {
      dt = DateTime.fromJSDate(date).toLocal();
    } else if (typeof date === 'string') {
      dt = DateTime.fromISO(date).toLocal();
      if (!dt.isValid) {
        const d = new Date(date);
        if (!isNaN(d.getTime())) {
          dt = DateTime.fromJSDate(d).toLocal();
        }
      }
    } else if (typeof date === 'number') {
      dt = DateTime.fromMillis(date).toLocal();
    } else if (DateTime.isDateTime(date)) {
      dt = date.toLocal();
    } else {
      const d = new Date(date);
      if (!isNaN(d.getTime())) {
        dt = DateTime.fromJSDate(d).toLocal();
      }
    }

    if (!dt || !dt.isValid) return '-';
    return dt.toFormat(formatStr);
  } catch (e) {
    return '-';
  }
};


interface DocumentWithTransactions {
  sourceTransactions?: Array<{ serial: string }>;
  sourceTransaction?: { serial: string };
  nextTransactions?: Array<{ serial: string }>;
  nextTransaction?: { serial: string };
}

export const formatDate = (date: string | Date, includeTime?: boolean): string => {
  if (date) {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();

    if (includeTime) {
      const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
    return `${day}-${month}-${year}`;
  }
  return '--:--:--';
};

export const formatHour = (date: string): string => {
  if (date) {
    const d = new Date(date);
    const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
  }
  return '--:--:--';
};

export const getExtraStatusName = (list: OrderExtraStatusAttributes[], type: string) => {
  const status = list.find((i) => i.type ==  type);
  return status?.description || '-';
};

export const getSourceDocument = (item: DocumentWithTransactions): string => {
  return item?.sourceTransactions?.[0]?.serial || 
         item?.sourceTransaction?.serial || '-';
};

export const getNextDocument = (item: DocumentWithTransactions): string => {
  return item?.nextTransactions?.[0]?.serial || 
         item?.nextTransaction?.serial || '-';
};
